import React, { useState } from "react";
// import { redirect } from "react-router-dom";
import { setCookie } from "../../helpers/cookies";

import "./login.css";

export default function Login() {
  const [error, setError] = useState(null);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    fetch(
      "https://platform.makemyhousegreen.com/connection/react/post/contractor_login.php",
      {
        method: "POST",
        body: JSON.stringify({ userName, password }),
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        if (data.username && data.login_level) {
          setCookie("user", data.username, 365);
          setCookie("login_level", data.login_level, 365);
          window.location.href = "/";
        } else {
          setError(data.error);
          setUserName("");
          setPassword("");
        }
      })
      .catch((error) => {
        setError(error);
      });
  };

  const handleUserName = (e) => {
    setUserName(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  return (
    <div className="container login pt-3">
      <div className="text-right">
        <img
          alt="MakeMyHouseGreen logo"
          src="https://platform.makemyhousegreen.com/images/header/logo.svg"
          className="img"
        />
      </div>
      <div className="d-flex flex-column align-items-center mt-5 pt-5">
        <h2 className="text-white">Welcome back!</h2>
        <p className="text-white mt-3">Log into your account</p>
        <form onSubmit={(e) => handleLogin(e)}>
          <div>
            <div className="mt-4 mb-3 login-form-input d-flex align-items-center">
              <div>
                <i className="icon icon-user icon-lg text-green mx-3" />
              </div>
              <input
                type="text"
                value={userName}
                placeholder="Username"
                onChange={(e) => handleUserName(e)}
              />
            </div>
            <div className="mb-3 login-form-input d-flex align-items-center">
              <div>
                <i className="icon icon-lock icon-lg text-green mx-3" />
              </div>
              <input
                type="password"
                value={password}
                placeholder="Password"
                onChange={(e) => handlePassword(e)}
              />
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-6">
              <button className="login-button btn btn-cta btn-block btn-lg py-2 text-small">
                Log In
              </button>
            </div>
          </div>
        </form>
      </div>
      {error && (
        <h5 className="text-red">Your username or password are incorrect</h5>
      )}
    </div>
  );
}
